import { computed } from 'vue';
import { ShortCodeService } from '@ht/lib-plural-vue';

export default function useDynamicText(data) {
  const dynamicTextData = computed(() => {
    if (data?.value) {
      return {
        ...data,
        value: new ShortCodeService(data.value)
          .matchAttributes()
          .getValue(),
      };
    }
    return { value: '' };
  });

  return dynamicTextData;
}
